import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HomeContent from './components/HomeContent';

export default function Home() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "韩国漫画网",
    "url": "https://www.koreanmanhwa.com",
    "description": "国内专业的韩国漫画在线阅读平台，提供海量好看韩国漫画资源，支持韩漫在线无删减下拉式免费阅读。",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://www.koreanmanhwa.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "韩国漫画网",
    "url": "https://www.koreanmanhwa.com",
    "description": "国内专业的韩国漫画在线阅读平台",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "contact@koreanmanhwa.com",
      "contactType": "customer service"
    }
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "韩国漫画网上的漫画都是免费的吗？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "是的，韩国漫画网上所有漫画均提供免费在线观看服务。我们致力于为广大韩漫爱好者提供优质、无删减的漫画阅读体验，无需付费即可畅享海量韩国漫画资源。"
        }
      },
      {
        "@type": "Question",
        "name": "网站上的漫画更新频率如何？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "我们与多家韩国漫画平台保持紧密合作，漫画更新与韩国本土保持同步。热门连载漫画通常每周更新1-2话，确保您能够第一时间看到最新的韩漫内容。"
        }
      },
      {
        "@type": "Question",
        "name": "为什么选择下拉式阅读方式？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "下拉式（Webtoon）是韩国漫画的主流阅读形式，相比传统的翻页式漫画，下拉式阅读更加流畅自然，特别适合在手机和电脑上阅读。"
        }
      },
      {
        "@type": "Question",
        "name": "漫画是否有删减或修改？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "我们始终坚持提供原汁原味的韩国漫画内容，所有漫画均为无删减版本。我们尊重创作者的原始表达，保留完整的故事情节和画面。"
        }
      }
    ]
  };

  return (
    <>
      <title>好看韩国漫画_韩漫在线_无删减下拉式韩漫免费阅读-韩国漫画网</title>
      <meta name="description" content="在韩国漫画网发现众多好看韩国漫画，支持韩漫在线无删减下拉式免费阅读。涵盖恋爱、热血、奇幻、搞笑等多种分类，每日同步更新，为您提供原汁原味的完整漫画体验。" />
      <meta name="keywords" content="好看韩国漫画,韩漫在线,无删减下拉式,韩漫免费阅读,韩国漫画网" />
      <link rel="canonical" href="https://www.koreanmanhwa.com/" />
      <meta property="og:title" content="好看韩国漫画_韩漫在线_无删减下拉式韩漫免费阅读-韩国漫画网" />
      <meta property="og:description" content="在韩国漫画网发现众多好看韩国漫画，支持韩漫在线无删减下拉式免费阅读。每日同步更新，为您提供原汁原味的完整漫画体验。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.koreanmanhwa.com/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="好看韩国漫画_韩漫在线_无删减下拉式韩漫免费阅读-韩国漫画网" />
      <meta name="twitter:description" content="在韩国漫画网发现众多好看韩国漫画，支持韩漫在线无删减下拉式免费阅读。" />
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <HomeContent />
        <Footer />
      </div>
    </>
  );
}